import { render, staticRenderFns } from "./Panoramic.vue?vue&type=template&id=2d6a9d99&scoped=true"
import script from "./Panoramic.vue?vue&type=script&lang=js"
export * from "./Panoramic.vue?vue&type=script&lang=js"
import style0 from "./Panoramic.vue?vue&type=style&index=0&id=2d6a9d99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6a9d99",
  null
  
)

export default component.exports